document.addEventListener('DOMContentLoaded', function () {
  const configEl = document.getElementById('QuickFilters-Config');
  const fallbackBase = configEl?.getAttribute('data-qf-collection-base') || '';

  const combinedWrapper = document.querySelector('[data-qf-combined-filter]');
  const recipientWrapper = document.querySelector('[data-qf-recipient-filter]');
  const recipientParentUrl = recipientWrapper?.getAttribute('data-qf-parent-url') || '';
  const collectionBase = combinedWrapper
    ? combinedWrapper.getAttribute('data-collection-base') || fallbackBase
    : recipientParentUrl || fallbackBase;

  function getSortPreservedUrl(pathname) {
    const sort = new URLSearchParams(window.location.search).get('sort_by');
    const params = new URLSearchParams();
    if (sort) params.set('sort_by', sort);
    return pathname + (params.toString() ? '?' + params.toString() : '');
  }

  function getActiveTypeSegment() {
    const active = document.querySelector('[data-filter-group="type"].is-active');
    return active ? active.getAttribute('data-filter-segment') || '' : '';
  }

  function getActiveColorSegment() {
    const select = document.querySelector('[data-qf-color-select]');
    return select ? select.value || '' : '';
  }

  function buildCombinedPath(typeSeg, colorSeg) {
    const parts = [];
    if (typeSeg) parts.push(typeSeg);
    if (colorSeg) parts.push(colorSeg);
    if (!parts.length) return collectionBase;
    return collectionBase + '/' + parts.join('+');
  }

  function syncCombinedUi(typeSeg, colorSeg) {
    if (!combinedWrapper) return;

    const allPill = combinedWrapper.querySelector('[data-filter-role="all"]');

    combinedWrapper.querySelectorAll('[data-filter-group="type"]').forEach((p) => {
      const seg = p.getAttribute('data-filter-segment');
      const isActive = typeSeg && seg === typeSeg;
      p.classList.toggle('is-active', isActive);
      let close = p.querySelector('.filter-close');
      if (isActive && !close) {
        close = document.createElement('span');
        close.className = 'filter-close';
        close.setAttribute('data-clear-filter', '');
        close.setAttribute('data-clear-scope', 'type');
        close.innerHTML = '&times;';
        p.appendChild(close);
      } else if (!isActive && close) {
        close.remove();
      }
    });

    if (allPill) allPill.classList.toggle('is-active', !typeSeg);

    const colorSelect = combinedWrapper.querySelector('[data-qf-color-select]');
    if (colorSelect) {
      colorSelect.value = colorSeg || '';
      colorSelect.classList.toggle('has-selection', Boolean(colorSeg));
    }

    const clearAllBtn = combinedWrapper.querySelector('[data-qf-clear-all]');
    if (clearAllBtn) {
      clearAllBtn.hidden = !(typeSeg || colorSeg);
    }
  }

  function parseCombinedPath(pathname) {
    if (!pathname.startsWith(collectionBase)) {
      return { typeSeg: '', colorSeg: '' };
    }
    const tail = pathname.slice(collectionBase.length).replace(/^\//, '');
    if (!tail) return { typeSeg: '', colorSeg: '' };
    const parts = tail.split('+').filter(Boolean);
    const colorSelect = combinedWrapper?.querySelector('[data-qf-color-select]');
    const colorOptions = colorSelect
      ? Array.from(colorSelect.options).map((o) => o.value).filter(Boolean)
      : [];

    let typeSeg = '';
    let colorSeg = '';
    parts.forEach((part) => {
      if (colorOptions.includes(part)) {
        colorSeg = part;
      } else {
        typeSeg = part;
      }
    });
    return { typeSeg, colorSeg };
  }

  function fetchAndRender(url, options = { updateToolbar: false }) {
    const controller =
      window.CollectionController?.instance || window.CollectionController?.init();

    if (controller) {
      controller.navigate(url, { ...options, source: 'quick-filter' });
      return;
    }

    window.location.assign(url);
  }

  function applyCombinedFilter(typeSeg, colorSeg) {
    const newUrl = getSortPreservedUrl(buildCombinedPath(typeSeg, colorSeg));
    syncCombinedUi(typeSeg, colorSeg);
    fetchAndRender(newUrl, { updateToolbar: false });
  }

  if (combinedWrapper) {
    const initial = parseCombinedPath(window.location.pathname);
    syncCombinedUi(initial.typeSeg, initial.colorSeg);

    combinedWrapper.querySelector('[data-qf-color-select]')?.addEventListener('change', function () {
      applyCombinedFilter(getActiveTypeSegment(), this.value || '');
    });

    combinedWrapper.querySelector('[data-qf-clear-all]')?.addEventListener('click', function (e) {
      e.preventDefault();
      applyCombinedFilter('', '');
    });
  }

  document.body.addEventListener('click', function (e) {
    const clearAllBtn = e.target.closest('[data-qf-clear-all]');
    const clearBtn = e.target.closest('[data-clear-filter]');
    const pill = e.target.closest('[data-ajax-filter]');

    if (clearAllBtn && combinedWrapper?.contains(clearAllBtn)) {
      e.preventDefault();
      applyCombinedFilter('', '');
      return;
    }

    if (clearBtn) {
      e.preventDefault();

      if (combinedWrapper && clearBtn.getAttribute('data-clear-scope') === 'type') {
        applyCombinedFilter('', getActiveColorSegment());
        return;
      }

      document.querySelectorAll('.filter-pill').forEach((p) => {
        p.classList.remove('is-active');
        const close = p.querySelector('.filter-close');
        if (close) close.remove();
      });

      const newUrl = getSortPreservedUrl(collectionBase);
      fetchAndRender(newUrl, { updateToolbar: false });

      if (combinedWrapper) {
        syncCombinedUi('', '');
      } else {
        const allPill =
          document.querySelector('[data-filter-role="all"]') ||
          document.querySelector('.filter-pill[href="' + collectionBase + '"]');
        if (allPill) allPill.classList.add('is-active');
      }
      return;
    }

    if (!pill) return;
    e.preventDefault();

    if (combinedWrapper && pill.closest('[data-qf-combined-filter]')) {
      if (pill.getAttribute('data-filter-role') === 'all') {
        applyCombinedFilter('', getActiveColorSegment());
        return;
      }

      if (pill.getAttribute('data-filter-group') === 'type') {
        const typeSeg = pill.getAttribute('data-filter-segment') || '';
        applyCombinedFilter(typeSeg, getActiveColorSegment());
      }
      return;
    }

    document.querySelectorAll('.filter-pill').forEach((p) => {
      p.classList.remove('is-active');
      const close = p.querySelector('.filter-close');
      if (close) close.remove();
    });

    const pillUrl = new URL(pill.getAttribute('href'), window.location.origin);
    const finalUrl = getSortPreservedUrl(pillUrl.pathname);

    pill.classList.add('is-active');
    if (!pill.querySelector('[data-clear-filter]')) {
      const span = document.createElement('span');
      span.className = 'filter-close';
      span.setAttribute('data-clear-filter', '');
      span.innerHTML = '&times;';
      pill.appendChild(span);
    }

    fetchAndRender(finalUrl, { updateToolbar: false });
  });

  window.addEventListener('popstate', () => {
    if (combinedWrapper) {
      const parsed = parseCombinedPath(window.location.pathname);
      syncCombinedUi(parsed.typeSeg, parsed.colorSeg);
    }
  });
});
